import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';
import { imageError } from '../utils/imageError';
import { computed } from 'mobx';
import { DataStore, AccessibilityStore } from '../stores';
import { sentenceCase } from 'change-case';

const Image = styled<any, any>('img')`
    ${propStyles};
    ${verticalAlign};
    flex-shrink: 0;
`;

interface IconProps {
    theme?: any;
    dataStore?: DataStore;
    accessibilityStore?: AccessibilityStore;
    fileName: string;
    accessibilityContext?: string;
    disableAltText?: boolean;
}

@inject('dataStore')
@inject('accessibilityStore')
@observer
class Icon extends React.Component<IconProps> {
    constructor(props) {
        super(props);
        this.handleImageError = this.handleImageError.bind(this);
    }

    handleImageError(e) {
        imageError(e.target);
    }

    // filename without extension
    @computed
    get iconFileName(): string {
        const { fileName: originalFileName = '' } = this.props;
        if (
            typeof originalFileName !== 'string' ||
            originalFileName.length === 0
        ) {
            return undefined;
        }
        let fileName = originalFileName;
        // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
        const ext = fileName.slice(
            Math.max(0, fileName.lastIndexOf('.')) || Infinity
        );
        // remove the extension to get clean filename for accessiblity alt text lookup
        if (ext) {
            fileName = fileName.replace(ext, '');
        }
        return fileName;
    }

    // extension without the dot (.)
    @computed
    get iconExtension(): string {
        const { fileName: originalFileName = '' } = this.props;
        if (
            typeof originalFileName !== 'string' ||
            originalFileName.length === 0
        ) {
            return undefined;
        }
        // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
        let ext = originalFileName.slice(
            (Math.max(0, originalFileName.lastIndexOf('.')) || Infinity) + 1
        );
        if (!ext) {
            ext = 'svg';
        }
        return ext;
    }

    @computed
    get iconSrc(): string {
        const { dataStore } = this.props;

        const fileName = `${this.iconFileName}.${this.iconExtension}`;
        const src = dataStore.assetStore.getAssetUrl(fileName);
        return src;
    }

    @computed
    get altText(): string {
        const {
            accessibilityStore,
            accessibilityContext,
            disableAltText,
        } = this.props;
        const { icons } = accessibilityStore;

        if (disableAltText) {
            return '';
        }

        let altText = '';
        if (icons && icons[this.iconFileName]) {
            altText += icons[this.iconFileName];
        } else {
            altText += sentenceCase(this.iconFileName);
        }
        if (accessibilityContext) {
            altText += ` ${accessibilityContext}`;
        }
        return altText;
    }

    render() {
        const src = this.iconSrc;
        if (!src) {
            return null;
        }
        return (
            <Image
                src={this.iconSrc}
                onError={this.handleImageError}
                alt={this.altText}
                {...this.props}
            />
        );
    }
}

export default withTheme(Icon) as any;



// WEBPACK FOOTER //
// ./src/Components/Icon.tsx